import { render, staticRenderFns } from "./DefaultWithdrawComplete.vue?vue&type=template&id=97afdc52&lang=pug&"
import script from "./DefaultWithdrawComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultWithdrawComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports